import { GeoDoctorId } from './types'

export interface GeoDoctor {
  /** "Dr. João Brunhara", as the byline shows it. */
  name: string
  /** Name without the prefix (JSON-LD `name`). */
  shortName: string
  registryName: string
  /** "urologista", as the byline shows it. */
  specialty: string
  jobTitle: string
  crm: string
  rqe: string
  /** "CRM-SP 161642 · RQE 118506 (Urologia)" (JSON-LD credential). */
  credential: string
  profilePath: string
  photo: string
  /** The small round photo of the reviewer line (Morgan, 24/10/2026: João's is the one of the Programa Control page). */
  avatar: string
  alumniOf: string
  sameAs: string[]
}

/** Credentials confirmed in the CREMESP Guia Médico on 24/10/2026 (PRD 3.6). */
export const GEO_DOCTORS: Record<GeoDoctorId, GeoDoctor> = {
  'joao-brunhara': {
    name: 'Dr. João Brunhara',
    shortName: 'João Brunhara',
    registryName: 'João Arthur Brunhara Alves Barbosa',
    specialty: 'urologista',
    jobTitle: 'Médico urologista',
    crm: 'CRM-SP 161642',
    rqe: 'RQE 118506',
    credential: 'CRM-SP 161642 · RQE 118506 (Urologia)',
    profilePath: '/author/dr-joao-brunhara',
    photo: '/landings/dr-joao-brunhara.webp',
    avatar: '/academy/programa-control-instructor.3fe427f5.webp',
    alumniOf: 'Faculdade de Medicina da Universidade de São Paulo',
    sameAs: ['https://omens.com.br/blog/dr-joao-brunhara/', 'https://www.medleve.com/equipe-medica/joao-brunhara']
  },
  'aline-erthal': {
    name: 'Dra. Aline Erthal',
    shortName: 'Aline Erthal',
    registryName: 'Aline Cocchi Erthal Ribeiro',
    specialty: 'dermatologista',
    jobTitle: 'Médica dermatologista',
    crm: 'CRM-SP 199764',
    rqe: 'RQE 98608',
    credential: 'CRM-SP 199764 · RQE 98608 (Dermatologia)',
    profilePath: '/author/dra-aline-erthal',
    photo: '/landings/doctors/aline-erthal.webp',
    avatar: '/landings/dermatology/aline-avatar.webp',
    alumniOf: 'Faculdade de Medicina da Universidade de São Paulo',
    sameAs: []
  },
  'carlos-seraphim': {
    name: 'Dr. Carlos Seraphim',
    shortName: 'Carlos Seraphim',
    registryName: 'Carlos Eduardo Seraphim',
    specialty: 'endocrinologista',
    jobTitle: 'Médico endocrinologista',
    crm: 'CRM-SP 156663',
    rqe: 'RQE 79256',
    credential: 'CRM-SP 156663 · RQE 79256 (Endocrinologia e Metabologia)',
    profilePath: '/author/dr-carlos-seraphim',
    photo: '/landings/dr-carlos-seraphim.webp',
    avatar: '/landings/dr-carlos-seraphim.webp',
    alumniOf: 'Faculdade de Medicina da Universidade de São Paulo',
    sameAs: ['https://www.medleve.com/equipe-medica/carlos-seraphim']
  }
}
